module.exports = __webpack_public_path__ + "media/新乐新厂区开业01.e9ff3565.mp4";